import * as React from 'react';

export interface Props {
  className?: any;
  children?: any;
}

export const Grid = (props: Props) => (
  <div
    className={`grid
    grid-columns-1
    grid-columns-2-m
    grid-columns-3-l
    ga2
    ${props.className}`}
  >
    {props.children}
  </div>
);

export default Grid;
